import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    stocks: [],
    stocks_filters: { offset: 0, limit: 20, ordering: 'owner_name,name' },
    stocks_count: 0,
    stocks_loaded: false,
    stocks_loading: false,
    stocks_loading_errors: null,
    stocks_cancel_source: null,
    stock_deleting: false,
};

const mutations = {
    updateStocks(state, stocks) {
        state.stocks = stocks;
        state.stocks_loaded = true;
    },
    updateStocksFilters(state, stocks_filters) {
        state.stocks_filters = stocks_filters;
    },
    updateStocksCount(state, stocks_count) {
        state.stocks_count = stocks_count;
    },
    updateStocksLoading(state, loading) {
        state.stocks_loading = loading;
        if (loading) {
            state.stocks_loaded = false;
        }
    },
    updateStocksLoadingErrors(state, errors) {
        state.stocks_loading_errors = errors;
    },
    updateStockDeleting(state, deleting) {
        state.stock_deleting = deleting;
    },
    updateStocksCancelSource(state, cancel_source) {
        state.stocks_cancel_source = cancel_source;
    },
};

const actions = {

    async setStockAsMainStock({ commit, dispatch, state }, params) {
        const url = `/api/stocks/${params.instance.id}/setasmain/`;
        try {
            const response = await axios.post(url);
            dispatch('fetchStocks');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async deleteStock({ commit, dispatch, state }, params) {
        commit('updateStockDeleting', true);

        const url = `/api/stocks/${params.instance.id}/archive/`;
        try {
            const response = await axios.post(url);
            commit('updateStockDeleting', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateStockDeleting', false);
            throw error;
        } finally {
            dispatch('session/fetchStats', null, { root: true });
            dispatch('fetchStocks');
        }
    },

    async unarchiveStock({ commit, dispatch, state }, params) {
        try {
            const url = `/api/stocks/${params.instance.id}/unarchive/`;
            const response = await axios.post(url);
            dispatch('fetchStocks');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async fetchStocks({ commit, dispatch, state }, params) {
        commit('updateStocksLoading', true);
        commit('updateStocksLoadingErrors', null);

        if (state.stocks_cancel_source) {
            state.stocks_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateStocksCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/stocks/', {
                params: state.stocks_filters,
                cancelToken: state.stocks_cancel_source?.token
            });
            commit('updateStocksLoading', false);
            commit('updateStocks', response.data.results);
            commit('updateStocksCount', response.data.count);
            commit('updateStocksCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            let error = utils.handleError(xhr_error);
            commit('updateStocksLoadingErrors', error.details);
            commit('updateStocksLoading', false);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
